module.exports = __webpack_public_path__ + "img/card-e1.f93844b6.png";